import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mm-ach-max-transfer-amount',
  templateUrl: './ach-max-transfer-amount.component.html',
  styleUrls: ['./ach-max-transfer-amount.component.scss']
})
export class AchMaxTransferAmountComponent implements OnInit {

  @Input() maxTransferAmount: string | null;
  @Input() transactionType: string | null;

  constructor() { }

  ngOnInit(): void {
  }
}